import React, { type ReactNode } from 'react';

import { ButtonBack } from '@pkg/components/Sections/Profile/Buttons';

import { ModalCloseButtonPositions } from '../../Modal.types';

import { ModalHeaderAlignments } from './Header.types';

import { CloseActionWrapper, HeaderContent, HeaderWrapper } from './styles';

export interface ModalHeaderProps {
    children: ReactNode;
    align?: ModalHeaderAlignments;
}

export interface CloseActionProps {
    position?: ModalCloseButtonPositions;
    onClose: () => void;
}

// TODO export/use this Header + Close action properly
export function ModalHeader({ children, align = ModalHeaderAlignments.Center }: ModalHeaderProps) {
    return (
        <HeaderWrapper>
            <HeaderContent $align={align}>{children}</HeaderContent>
        </HeaderWrapper>
    );
}

export function CloseAction({ onClose, position = ModalCloseButtonPositions.Corner }: CloseActionProps) {
    return (
        <CloseActionWrapper $position={position}>
            <ButtonBack color="translucent" size="smallMedium" variant="solid" onClick={onClose} />
        </CloseActionWrapper>
    );
}
